import { PaginationRequest } from "../../objects/pagination";
import { customFetch } from "../../utils/http";

export const getBrands = async (req: PaginationRequest) => {
  const queryParams = new URLSearchParams();
  queryParams.set("page", String(req.page));
  queryParams.set("size", String(req.size));
  if (req.search) queryParams.set("search", req.search);
  return await customFetch(
    `v1/brand?${queryParams}`,
    {
      method: "GET",
    }
  );
};

export const getBrand = async (id: string) => {
  return await customFetch(`v1/brand/${id}`, {
    method: "GET",
  });
};
export const createBrand = async (data: any) => {
  return await customFetch("v1/brand", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateBrand = async (id: string, data: any) => {
  return await customFetch(`v1/brand/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteBrand = async (id: string) => {
  return await customFetch(`v1/brand/${id}`, {
    method: "DELETE",
  });
};


export const getTopBrands = async () => {
  return await customFetch("v1/brand/top", {
    method: "GET",
  });
};

export const addTopBrand = async (data: any) => {
  return await customFetch("v1/brand/top", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateTopBrand = async (brandId: string, data: any) => {
  return await customFetch(`v1/brand/top/${brandId}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteTopBrand = async (brandId: string) => {
  return await customFetch(`v1/brand/top/${brandId}`, {
    method: "DELETE",
  });
};
